export const STATIC_URLS = ["/zombs", "/clix", "/snip3down"]



// WEBPACK FOOTER //
// ./src/store/utils/util.constants.js